import { useResource } from '@landsbankinn/l16n';
import { useEffect } from 'react';
import { useMarketingAreaContext } from 'src/components/Layout/Desktop/MarketingContent/MarketingAreaContext';
import { Loading } from 'src/components/Loading';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { AppHubStateType } from 'src/services/AppHubService';
import { useAppService } from './AppContext';
import { res } from './AppPending.res';
import { AppQR } from './AppQR';
import { AppQRDebug } from './AppQRDebug';

export function AppPending() {
  const { state, start } = useAppService();
  const { setCustomComponent } = useMarketingAreaContext();
  const { isMobile, isXL } = useScreenSize();

  useEffect(() => {
    start();
  }, [start]);

  useEffect(() => {
    if (isXL) {
      setCustomComponent(<AppQR isMobile={isMobile} />);
    }
  }, [isMobile, isXL, setCustomComponent]);

  return (
    <>
      <AppPendingInternal />
      <AppQRDebug state={state} />
    </>
  );
}

export function AppPendingInternal() {
  const { r } = useResource();
  const { state } = useAppService();

  const isCompleted = state?.type === AppHubStateType.Completed;

  const title = isCompleted ? res.completedAppTitle : res.loadingAppTitle;
  const description = isCompleted
    ? res.completedAppDescription
    : res.loadingAppDescription;
  return <Loading title={r(title)} description={r(description)} />;
}
